<template lang='pug'>
v-list(class='drawer-menu')
  template(v-for='item in items')
    v-list-group(
      v-if='item.items'
      v-model='item.active'
      :key='item.title'
      :prepend-icon="item.action"
      no-action
    )
      v-list-tile(slot='activator')
        v-list-tile-content
          v-list-tile-title {{ item.title }}
      v-list-tile(
        v-for='subItem in item.items'
        :key='subItem.title'
        :to='{ name: subItem.route }'
        @click='$emit("click", subItem)'
        v-if='checkAccess(subItem)'
      )
        v-list-tile-content
          v-list-tile-title {{ subItem.title }}
        v-list-tile-action
          v-icon {{ subItem.action }}
    v-list-tile(
      v-else
      :key='item.title'
      :to='{ name: item.route }'
      @click='$emit("click", item)'
    )
      v-list-tile-action
        v-icon {{ item.action }}
      v-list-tile-title {{ item.title }}
</template>

<script>
import { intersection, castArray, get } from 'lodash'
export default {
  props: {
    items: {
      type: Array,
      required: true
    }
  },

  methods: {
    checkAccess(menu) {
      // список пермиций раздела меню
      const mp = castArray(get(menu, 'available', []))
      // если не получили никакие пермиции
      // считаем что пункт меню открыт для пользователя
      if (0 === mp.length) {
        return true
      }
      // проверим пермиции пользователя на пересечение
      // с пермициями раздела меню
      const up = get(this.user, 'privileges', [])
      return intersection(mp, up).length > 0
    }
  },

  computed: {
    user() {
      return this.$user.get()
    }
  }
}
</script>

<style scoped>
.drawer-menu >>> .v-list__group:first-child:before {
  display: none;
}
</style>
